define(function(require) {
	// general
	const Backbone = require('backbone');
	const Modal = require('backbone.modal');
	const Radio = require('backbone.radio');
	const AddAttachmentChannel = Radio.channel('addAttachmentChannel');
	const Utils = require('civicsUtils/general_utilities');


	// models
	const AttachmentModel = require('civicsModels/attachment_model');

	// collections
	const AttachmentCollection = require('civicsCollections/attachment_collection');

	// templates
	const AddAttachmentTemplate = require('civicsViews/new_attachments/upload_modal/templates/t_cpv_add_attachment.hbs');
	// views
	const RowView = require('civicsViews/new_attachments/upload_modal/v_itv_add_attachment');

	//utils
	const ViewManager = require('civicsUtils/view_manager');

	return Marionette.CompositeView.extend({
		initialize: function(options) {
			this.config = options.config || {};
			this.config.globalConfig = ViewManager.globalConfig();
			this.productFamily = options.productFamily;
			this.catalog = options.catalog;
			this.modalRegion = options.modalRegion;
			this.isAddProcess = options.isAddProcess;
			this.parentMoniker = options.parentMoniker;
			this.parentPrimaryKey = options.parentPrimaryKey;
			this.collection = new AttachmentCollection();
			this.existingAttachmentCollection = options.existingAttachmentCollection;
			this.documentTypeCollection = options.documentTypeCollection;
		},
		template: AddAttachmentTemplate,
		className: 'add-attach',
		childView: RowView,
		childViewContainer: '.saved-attachments',
		childEvents: {
			'attachment:post:save': 'onPostSaveAttachment',
			'attachment:before:save': 'onValidateAttachment',
			'attachment:remove': 'onRemoveAttachment',
		},
		childViewOptions: function(model, index) {
			return {
				config: this.config,
				documentTypeCollection: this.documentTypeCollection,
				parentMoniker: this.parentMoniker,
				parentPrimaryKey: this.parentPrimaryKey,
				isAddProcess: this.isAddProcess,
				attachment_index: index
			};
		},
		ui: {
			backButton: '.back-modal-button',
			closeButton: '.close-modal-button',
			dropFile: '.drop-file',
			saveButton: '.save-modal-button',
			selectFiles: '.select-file',
			genericLabel: '.generic-label',
			attachModal: '.attach-modal',
			browseLink: '.browse-link'
		},
		events: {
			'click @ui.backButton': 'closeModal',
			'click @ui.saveButton': 'onSaveAndUpload',
			'click @ui.closeButton': 'closeModal',
			'click .bbm-btn-close': 'closeModal',
			'drop .attach-modal': 'dropHandler',
			'dragover .attach-modal': 'dragEnter',
			'click @ui.browseLink': 'openFileSelect',
			'change @ui.selectFiles': 'saveSelectedFile',

		},
		onShow: function() {
			this.setButtons(false);
			this.ui.saveButton.prop("disabled", true);
		},
		onRender: function() {
			var genericLabel = i18n.t('CIVICS.ATTACHMENTS.GENERIC_LABEL');
			if (genericLabel.length > 0)
				this.ui.genericLabel.html(genericLabel);

			if (this.isAddProcess)
				this.ui.saveButton.html(i18n.t('CIVICS.COMMON.SAVE'));

		},
		dragEnter: function(e) {
			var evt = e.originalEvent;
			evt.preventDefault();
		},
		dropHandler: function(e) {
			var self = this;

			var evt = e.originalEvent;
			evt.preventDefault();
			evt.stopPropagation();
			e.preventDefault();
			e.stopPropagation();

			var files = evt.dataTransfer.files;
			if (files) {
				self.saveForUpload(files);
			}
		},
		setButtons: function(showClose) {
			if (showClose && showClose === true) {
				this.ui.backButton.hide();
				this.ui.saveButton.hide();
				this.ui.dropFile.hide();
				this.ui.closeButton.show();
			} else {
				this.ui.backButton.show();
				this.ui.saveButton.show();
				this.ui.dropFile.show();
				this.ui.closeButton.hide();
			}
		},
		isDuplicateFile: function(fileName) {
			var self = this;
			var attachments = self.collection.where({ filename: fileName });
			if (attachments.length > 0) {
				return true;
			}

			return false;
		},
		saveForUpload: function(files) {
			var self = this;
			// We are saving a new file.  Save off description from old files
			this.children.each(function(view) {
				view.onSaveDescription();
			});

			_.each(files, function(myFile) {
				if (!self.isDuplicateFile(myFile.name)) {
					// Sanitize filename to remove invalid characters before upload
					var sanitizedName = Utils.sanitizeFileNameForUpload(myFile.name);
					// Create new File object with sanitized name (browser File object is immutable)
					var sanitizedFile = new File([myFile], sanitizedName, { type: myFile.type });
					var myAttachment = new AttachmentModel();
					myAttachment.set('file', sanitizedFile);
					myAttachment.set('fileName', sanitizedName);
					myAttachment.set('catalog', self.catalog);
					self.collection.add(myAttachment);
				}
			});

			this.render();
			this.setButtons(false);
		},
		openFileSelect: function(e) {
			var self = this;
			var evt = e.originalEvent;
			evt.preventDefault();

			$('.select-file').click();

		},
		saveSelectedFile: function() {
			var self = this;
			// We are saving a new file.  Save off description from old files
			this.children.each(function(view) {
				view.onSaveDescription();
			});

			self.ui.saveButton.prop("disabled", false);

			var fileList = this.ui.selectFiles[0].files;

			_.each(fileList, function(myFile) {


				if (!self.isDuplicateFile(myFile.name)) {
					// Sanitize filename to remove invalid characters before upload
					var sanitizedName = Utils.sanitizeFileNameForUpload(myFile.name);
					// Create new File object with sanitized name (browser File object is immutable)
					var sanitizedFile = new File([myFile], sanitizedName, { type: myFile.type });
					var myAttachment = new AttachmentModel();
					myAttachment.set('file', sanitizedFile);
					myAttachment.set('fileName', sanitizedName);


					self.collection.add(myAttachment);
				}
			});
			this.render();
			this.setButtons(false);
		},
		onSaveAndUpload: function() {
			var self = this;
			var hasError = false;
			self.ui.dropFile.hide();
			self.ui.saveButton.prop("disabled", true);
			setTimeout(function() {
				if (typeof self.ui.saveButton === 'object')
					self.ui.saveButton.prop('disabled', false);
			}, 500);

			ViewManager.loading(true);
			var defArr = [];
			this.children.each(function(view, index) {
				if (typeof view.isUploaded === 'undefined' && !view.isUploaded) {
					if (view.isAddProcess) {
						view.validateChildViewAttachment(view);
						if (view.hasValidAttachment) //if it pass the first check on the AddInstrument, proceed with the second attachment validation method.
							view.validateChildViewAttachment2(self.catalog);
					} else {
						view.validateChildViewAttachment2(self.catalog);
					}
					if (view.hasValidAttachment) {
						defArr.push(view.onUploadSave(self.catalog));
					} else {
						hasError = true;
					}
				}
			});

			$.when.apply($, defArr).done(function() {
				ViewManager.loading(false);
				if (hasError) {
					self.setButtons(false);
					self.scrollToError();
				} else {
					self.closeAndTriggerModal();
					Utils.civicsToastPop( i18n.t('CIVICS.ATTACHMENTS.ATTACHMENTS_UPDATED'), "success");
				}
			}).fail(function() {
				ViewManager.loading(false);
				self.setButtons(false);
				self.scrollToError();
			});
		},
		onPostSaveAttachment: function(childView, myModel) {
			childView.isUploaded = true;

			AddAttachmentChannel.trigger('attachments:added', myModel);
		},
		onValidateAttachment: function(view) {
			return AddAttachmentChannel.trigger('attachments:validate', view);
		},
		onRemoveAttachment: function(childView) {
			var self = this;
			// The attachment has not yet been uploaded or added to the database, so we can just remove the child view.
			// remove the model from the collection based on cid.
			this.collection.remove(this.collection.get({ cid: childView.model.cid }));

			this.removeChildView(childView);
			childView.destroy();

			self.ui.saveButton.prop("disabled", (this.collection.length <= 0));
		},
		closeAndTriggerModal: function(myModel){
			this.modalRegion.hideModal(() => AddAttachmentChannel.trigger('attachments:done', myModel));
		},
		closeModal: function(e, myModel) {
			//Reload attachment box upon closing when there is a valid attachment during upload
			var validAttachment = this.children.find(function(view) {
				return view.hasValidAttachment;
			});

			if(validAttachment)
				this.closeAndTriggerModal();
			else
				this.modalRegion.hideModal();
		},
		scrollToError: function() {
			var scrollTop;
			var containerModal = $('.bbm-modal');
			var scrollTop = $(containerModal.find('.error-message:visible:first').parent()).offset().top - containerModal.offset().top + containerModal.scrollTop();

			if (scrollTop) {
				containerModal.animate({
					scrollTop: scrollTop
				},{
					duration: 500,
					complete: function() {
						containerModal.find('.error-message:visible:first').get(0).focus();
					}
				});
			}
		},
	});
});
